import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import telusLogoWhiteEn from './img/telusLogoWhiteEn.png';
import telusLogoWhiteFr from './img/telusLogoWhiteFr.png';

const Footer = (props: WithTranslation) => {
    const { t, i18n } = props;

    const data = [
        {
            label: t('footer_about_us'),
            url: t('footer_about_us_url'),
        },
        {
            label: t('footer_technical_support'),
            url: t('footer_technical_support_url'),
        },
        {
            label: t('footer_privacy'),
            url: t('footer_privacy_url'),
        },
        {
            label: t('footer_accessibility'),
            url: t('footer_accessibility_url'),
        },
        {
            label: t('footer_user_terms'),
            url: t('footer_user_terms_url'),
        },
    ];

    const imageComponent = (
        <img
            className="footer-copyright__logo"
            src={i18n.language === 'en' ? telusLogoWhiteEn : telusLogoWhiteFr}
            alt={t('footer_logo_alt_text', { ns: 'accessibility' })}
        />
    );

    const getCurrentYear = () => {
        return new Date().getFullYear();
    };

    return (
        <footer className="footer-container">
            <section className="footer-nav__section">
                <nav
                    className="footer-nav"
                    aria-label={t('footer_nav_aria_label', { ns: 'accessibility' })}
                >
                    <ul className="footer-nav__list">
                        {data.map((item, i) => (
                            <li key={i} className="footer-nav__item">
                                <a
                                    href={item.url}
                                    className="standalone-link"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
                <p className="footer__legal-text">{t('footer_legal_text')}</p>
            </section>
            <section className="footer-copyright__section">
                <div className="footer-copyright">
                    {imageComponent}
                    <p className="footer-copyright__text body-medium">
                        &copy; {getCurrentYear()} {t('footer_copyright')}
                    </p>
                </div>
            </section>
        </footer>
    );
};

export default withTranslation()(Footer);
